import React, { useState } from "react";
import { RiMenuAddFill } from "react-icons/ri";
import { FiPlusSquare, FiMinusSquare, FiSearch } from "react-icons/fi";
import { AiOutlineDelete } from "react-icons/ai";
import { FaCheckCircle } from "react-icons/fa";

// Shared HSN list component
function HSNList({ data, rows, setRows, onDeleteClick }) {
  return Array.from({ length: 6 }).map((_, outerIdx) => {
    const row = rows[outerIdx] || {};
    return (
      <div key={outerIdx} className="rounded-md">
        <div className="flex gap-2 border-b p-2 items-center">
          <RiMenuAddFill
            className="text-xl cursor-pointer"
            onClick={() =>
              setRows((prev) => ({
                ...prev,
                [outerIdx]: {
                  ...(prev[outerIdx] || {}),
                  topAdd: !row.topAdd,
                  showLayout: true,
                },
              }))
            }
          />
          <AiOutlineDelete
            className="text-xl cursor-pointer"
            onClick={() => onDeleteClick(outerIdx)}
          />
          {row.showLayout ? (
            <FiMinusSquare
              className="text-xl text-blue-500 cursor-pointer"
              onClick={() =>
                setRows((prev) => ({
                  ...prev,
                  [outerIdx]: { ...(prev[outerIdx] || {}), showLayout: false },
                }))
              }
            />
          ) : (
            <FiPlusSquare
              className="text-xl text-blue-500 cursor-pointer"
              onClick={() =>
                setRows((prev) => ({
                  ...prev,
                  [outerIdx]: { ...(prev[outerIdx] || {}), showLayout: true },
                }))
              }
            />
          )}
          <input type="checkbox" className="w-5 h-5 accent-blue-500" />
          <h1>{`0${outerIdx + 1}`}</h1>
        </div>

        {row.topAdd && (
          <div className="ml-10 my-2 transition-all">
            <div className="flex border rounded-full w-72">
              <div className="bg-gray-400 rounded-full px-3 flex items-center text-white">
                <FiSearch className="text-sm" />
              </div>
              <input
                placeholder=" | 00 enter your SAC code"
                className="flex-1 rounded text-sm px-2"
              />
              <button className="bg-gray-400 text-white px-4 rounded-r-sm text-sm">
                Add
              </button>
            </div>
          </div>
        )}

        {row.showLayout && (
          <div className="ml-10 space-y-1">
            {data.map((code, innerIdx) => {
              const expanded = row.expanded?.[innerIdx];
              return (
                <div key={innerIdx}>
                  <div className="flex gap-2 items-center">
                    {innerIdx < 2 ? (
                      <RiMenuAddFill
                        className="text-xl cursor-pointer"
                        onClick={() =>
                          setRows((prev) => ({
                            ...prev,
                            [outerIdx]: {
                              ...(prev[outerIdx] || {}),
                              expanded: {
                                ...(prev[outerIdx]?.expanded || {}),
                                [innerIdx]: !expanded,
                              },
                            },
                          }))
                        }
                      />
                    ) : (
                      <span className="w-5" />
                    )}
                    <AiOutlineDelete
                      className="text-xl cursor-pointer"
                      onClick={() => onDeleteClick(code)}
                    />
                    <FiPlusSquare
                      className="text-xl cursor-pointer"
                      onClick={() => onDeleteClick(code)}
                    />
                    <input
                      type="checkbox"
                      className="w-5 h-5 accent-blue-500"
                    />
                    <h1>{code}</h1>
                  </div>
                  {expanded && (
                    <div className="ml-10 my-2 transition-all">
                      <div className="flex border rounded-full w-72">
                        <div className="bg-gray-400 rounded-full px-3 flex items-center text-white">
                          <FiSearch className="text-sm" />
                        </div>
                        <input
                          placeholder=" | 01 enter your SAC code"
                          className="flex-1 rounded text-sm px-2"
                        />
                        <button className="bg-gray-400 text-white px-4 rounded-r-sm text-sm">
                          Add
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  });
}

// First modal
function SelectPopup_Product_Details({ openSecondModal, onDelete }) {
  const [rows, setRows] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const data = ["0134", "01345", "0134567"];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl shadow-lg w-[750px] max-h-[85vh] overflow-y-auto p-6 relative">
        <div className="flex justify-between items-center px-4 pt-4">
          <div>
            <h1 className="text-lg font-semibold">Select HSN</h1>
            <p className="text-sm">You can select only one HSN</p>
          </div>
          <button onClick={openSecondModal} className="text-2xl">
            &times;
          </button>
        </div>
        <hr className="my-2" />
        <div className="flex items-center max-w-[550px] mx-auto border rounded-md bg-gray-200 px-4">
          <input
            placeholder="Search"
            className="flex-1 bg-gray-200 p-2 focus:outline-none"
          />
          <FiSearch className="text-lg text-gray-600 mr-2" />
        </div>
        <div className="px-4 mt-3">
          <HSNList
            data={data}
            rows={rows}
            setRows={setRows}
            onDeleteClick={onDelete}
          />
        </div>
      </div>
      {showSuccess && (
        <EditLinkUnitModal
          onClose={() => setShowSuccess(false)}
          reopenFirst={() => setShowSuccess(false)}
        />
      )}
    </div>
  );
}

// Second modal (edit + link)
function EditLinkUnitModal({ onClose, reopenFirst, openThird }) {
  const [hsn, setHsn] = useState("01");
  const [defaultUnit, setDefaultUnit] = useState("Kg");
  const [otherUnits, setOtherUnits] = useState("Ton, Pcs");
  const [saved, setSaved] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    setSaved(true);
  };
  const onDone = () => {
    setSaved(false);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-md shadow-lg w-[450px] p-6 relative">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">Edit Link Unit to HSN</h2>
          <button onClick={reopenFirst} className="text-xl">
            &times;
          </button>
        </div>
        <form onSubmit={onSubmit} className="space-y-4">
          {/* On click, this opens the 3rd modal */}
          <div>
            <label>HSN*</label>
            <select
              value={hsn}
              onClick={openThird}
              className="w-full border rounded px-3 py-2"
            >
              {["01", "02", "03"].map((v) => (
                <option key={v} value={v}>
                  {v}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label>Default Unit*</label>
            <input
              value={defaultUnit}
              onClick={openThird}
              className="w-full border rounded px-3 py-2"
            />
          </div>
          <div>
            <label>Other Allowed Units*</label>
            <textarea
              value={otherUnits}
              onClick={openThird}
              rows={3}
              className="w-full border rounded px-3 py-2"
            />
          </div>
          <div className="text-right">
            <button
              type="submit"
              className="bg-[#008bcf] text-white px-5 py-2 rounded"
            >
              Save
            </button>
          </div>
        </form>
      </div>
      {saved && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-72 gap-4 flex flex-col py-5 text-center relative">
            <div className="flex w-full justify-center">
              <FaCheckCircle className="text-6xl text-green-600 text-center" />
            </div>
            <div className="flex justify-center items-center mb-2">
              <h3 className="text-md text-center font-semibold">
                Unit Saved Successfully!
              </h3>
            </div>
            <div className="flex justify-center gap-5">
              <button
                onClick={onDone}
                className="bg-green-600 text-white px-4 py-1 rounded"
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// Third modal (same as first but with "Add Product" button)
function SelectPopup_Product_Details2({ onClose }) {
  const [rows, setRows] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const data = ["0134", "01345", "0134567"];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl shadow-lg w-[750px] max-h-[85vh] overflow-y-auto p-6 relative">
        <div className="flex justify-between items-center px-4 pt-4">
          <div>
            <h1 className="text-lg font-semibold">Select HSN</h1>
            <p className="text-sm">You can select only one HSN</p>
          </div>
          <button onClick={onClose} className="text-2xl">
            &times;
          </button>
        </div>
        <hr className="my-2" />
        <div className="flex items-center max-w-[550px] mx-auto border rounded-md bg-gray-200 px-4">
          <input
            placeholder="Search"
            className="flex-1 bg-gray-200 p-2 focus:outline-none"
          />
          <FiSearch className="text-lg text-gray-600 mr-2" />
        </div>
        <div className="px-4 mt-3">
          <HSNList
            data={data}
            rows={rows}
            setRows={setRows}
            onDeleteClick={() => {}}
          />
        </div>
        <div className="flex justify-end mt-4">
          <button
            onClick={onClose}
            className="bg-[#008bcf] text-white px-5 py-2 rounded"
          >
            Add Product
          </button>
        </div>
      </div>
    </div>
  );
}

// Main app
export default function App() {
  const [stage, setStage] = useState(1);

  return (
    <>
      {stage === 1 && (
        <SelectPopup_Product_Details
          openSecondModal={() => setStage(2)}
          onDelete={(data) => console.log("delete 1:", data)}
        />
      )}
      {stage === 2 && (
        <EditLinkUnitModal
          onClose={() => setStage(0)}
          reopenFirst={() => setStage(1)}
          openThird={() => setStage(3)}
        />
      )}
      {stage === 3 && (
        <SelectPopup_Product_Details2 onClose={() => setStage(2)} />
      )}
    </>
  );
}
